import { render, staticRenderFns } from "./TestCaseReportPage.vue?vue&type=template&id=1dcc54ac&"
import script from "./TestCaseReportPage.vue?vue&type=script&lang=js&"
export * from "./TestCaseReportPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dcc54ac')) {
      api.createRecord('1dcc54ac', component.options)
    } else {
      api.reload('1dcc54ac', component.options)
    }
    module.hot.accept("./TestCaseReportPage.vue?vue&type=template&id=1dcc54ac&", function () {
      api.rerender('1dcc54ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/testCaseReport/TestCaseReportPage.vue"
export default component.exports